<!-- When on mobile devices, there's a conflict with the tooltip and the ag-grid context
 menu.  UX's decision was to just disable the tooltip on mobile devices. -->

<!-- The prism-tooltip component interferred with the ability to truncate and ellipsize
 the comma separated tags. -->
<prism-tooltip [text]="displayValue()" [disabled]="!enableTooltip()">
	<div class="tags" data-testid="sh-tags-container">
		{{ displayValue() }}
	</div>
</prism-tooltip>
